export default __webpack_public_path__ + "static/media/ic-course (2).c26a17e8.svg";